interface LayoutProps {
  children: any;
}

export const DefaultLayout = ({ children }: LayoutProps) => <>{children}</>;
